import DiningExperience from "@inter-ikea-range/dining-experience";
import Skalsta from "@inter-ikea-range/skalsta";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";
// room experience
export const diningExperience = (settings: EnvironmentSettings) => DiningExperience(settings);

// range packages
export const diningPackages = (_settings: EnvironmentSettings): Experience[] => [
  Skalsta(_settings),
];
